<header
  class="auth-app-header"
  *ngIf="
    loginBtn && headerStyle !== 'category' && headerStyle !== 'privacyAndPolicy'
  "
>
  <div class="auth-app-header__inner site-content-container">
    <a
      class="auth-app-header__brand"
      routerLink="/portal"
      (click)="onHomeNavigation()"
      aria-label="CitizeX home"
    >
      <img src="../../../../assets/images/logo-text.png" alt="CitizeX" />
    </a>

    <nav class="auth-app-header__primary-nav" aria-label="Primary navigation">
      <a routerLink="/events" routerLinkActive="is-active"> Events </a>
      <a routerLink="/representatives" routerLinkActive="is-active">
        Representatives
      </a>
      <a routerLink="/posts" routerLinkActive="is-active"> Posts </a>
      <a routerLink="/polls" routerLinkActive="is-active"> Polls </a>
    </nav>

    <form
      class="auth-app-header__search cx-search-control"
      (submit)="onEnter($event)"
    >
      <app-icon
        name="search"
        class="cx-search-control__icon"
        aria-hidden="true"
      ></app-icon>
      <input
        type="search"
        class="cx-search-control__input"
        name="authenticatedSearch"
        placeholder="Search for elected officials and CitizeX users"
        [(ngModel)]="searchValue"
        (input)="onChangeSearch(searchValue)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        autocomplete="off"
        aria-label="Search for elected officials and CitizeX users"
      />
      <button
        *ngIf="searchValue"
        type="button"
        class="cx-search-control__clear"
        (click)="clearHeaderSearch()"
        aria-label="Clear search"
      >
        <app-icon name="x" aria-hidden="true"></app-icon>
      </button>
      <div
        class="auth-app-header__suggestions"
        *ngIf="showSuggestions && searchSuggetionList.length > 0"
      >
        <button
          type="button"
          *ngFor="let item of searchSuggetionList"
          (mousedown)="$event.preventDefault()"
          (click)="searchSelect(item)"
        >
          <span [innerHTML]="item.displayName"></span>
        </button>
      </div>
    </form>

    <nav class="auth-app-header__tools" aria-label="Account tools">
      <div class="auth-app-header__notification-wrap">
        <button
          type="button"
          class="auth-app-header__tool auth-app-header__tool--alerts"
          [attr.aria-expanded]="notificationsOpen"
          [attr.aria-label]="
            notificationCount > 0
              ? notificationCount + ' unread alerts. Open alerts'
              : 'Open alerts'
          "
          aria-controls="desktop-notifications"
          (click)="toggleNotifications($event)"
        >
          <span class="auth-app-header__icon-badge">
            <app-icon name="bell" aria-hidden="true"></app-icon>
            <span *ngIf="notificationCount > 0">{{
              notificationCount > 99 ? '99+' : notificationCount
            }}</span>
          </span>
        </button>

        <div
          *ngIf="notificationsOpen"
          id="desktop-notifications"
          class="auth-app-header__notifications"
        >
          <div class="auth-app-header__panel-title">
            <strong>Alerts</strong>
            <button
              type="button"
              (click)="notificationsOpen = false"
              aria-label="Close alerts"
            >
              <app-icon name="x" aria-hidden="true"></app-icon>
            </button>
          </div>
          <button
            type="button"
            class="auth-app-header__notification"
            *ngFor="let notification of notificationList | slice : 0 : 6"
            [class.auth-app-header__notification--unread]="!notification.isRead"
            (click)="
              updateNotification(notification); notificationsOpen = false
            "
          >
            <strong>{{ notification.byProfileName || 'CitizeX' }}</strong>
            <span>{{ notificationLabel(notification) }}</span>
            <small>{{ notification.daysAgo }}</small>
          </button>
          <p
            *ngIf="notificationList.length === 0"
            class="auth-app-header__empty"
          >
            You’re all caught up.
          </p>
        </div>
      </div>

      <div class="auth-app-header__account-wrap">
        <button
          type="button"
          class="auth-app-header__avatar-button"
          [attr.aria-expanded]="accountMenuOpen"
          aria-controls="desktop-account-menu"
          aria-haspopup="menu"
          aria-label="Open account menu"
          (click)="toggleAccountMenu($event)"
        >
          <img
            [src]="getAvatarUrl(defaultProfile.profileImage)"
            onerror="this.src='/assets/images/noprofile2.png';"
            alt=""
          />
          <app-icon
            name="chevron-down"
            class="auth-app-header__avatar-chevron"
            aria-hidden="true"
          ></app-icon>
        </button>

        <div
          *ngIf="accountMenuOpen"
          id="desktop-account-menu"
          class="auth-app-header__account-menu"
          role="menu"
        >
          <div class="auth-app-header__account-summary">
            <strong>{{ accountDisplayName }}</strong>
            <small *ngIf="accountHandle">&#64;{{ accountHandle }}</small>
          </div>
          <a
            *ngIf="defaultProfile.tagName"
            role="menuitem"
            [routerLink]="['/profile/view-profile', defaultProfile.tagName]"
            (click)="closeAccountMenu()"
          >
            <app-icon name="user-round" aria-hidden="true"></app-icon>
            Your Page
          </a>
          <a
            *ngIf="defaultProfile.id"
            role="menuitem"
            [routerLink]="['/profile/edit-profile', defaultProfile.id]"
            (click)="closeAccountMenu()"
          >
            <app-icon name="pencil" aria-hidden="true"></app-icon>
            Edit profile
          </a>
          <a
            role="menuitem"
            routerLink="/account-settings"
            (click)="closeAccountMenu()"
          >
            <app-icon name="settings" aria-hidden="true"></app-icon>
            Account settings
          </a>
          <button
            type="button"
            role="menuitem"
            (click)="logOut(); closeAccountMenu()"
          >
            <app-icon name="log-out" aria-hidden="true"></app-icon>
            Log out
          </button>
        </div>
      </div>
    </nav>

    <div class="auth-app-header__mobile-tools">
      <button
        type="button"
        (click)="mobileSearchOpen = !mobileSearchOpen"
        [attr.aria-expanded]="mobileSearchOpen"
        aria-label="Open search"
      >
        <app-icon
          name="search"
          class="cx-icon--md"
          aria-hidden="true"
        ></app-icon>
      </button>
      <button
        #mobileMenuButton
        type="button"
        (click)="openMobileMenu()"
        [attr.aria-expanded]="isMenuOpen"
        aria-label="Open navigation menu"
      >
        <span class="cx-mobile-menu-icon" aria-hidden="true"></span>
      </button>
    </div>
  </div>

  <form
    *ngIf="mobileSearchOpen"
    class="auth-app-header__mobile-search cx-search-control"
    (submit)="onEnter($event)"
  >
    <app-icon
      name="search"
      class="cx-search-control__icon"
      aria-hidden="true"
    ></app-icon>
    <input
      type="search"
      class="cx-search-control__input"
      name="mobileAuthenticatedSearch"
      placeholder="Search officials and CitizeX users"
      [(ngModel)]="searchValue"
      (input)="onChangeSearch(searchValue)"
      autocomplete="off"
      aria-label="Search officials and CitizeX users"
    />
    <button
      type="button"
      class="cx-search-control__clear"
      (click)="clearMobileHeaderSearch()"
      [attr.aria-label]="searchValue ? 'Clear search' : 'Close search'"
    >
      <app-icon name="x" aria-hidden="true"></app-icon>
    </button>
    <div
      class="auth-app-header__mobile-suggestions"
      *ngIf="searchSuggetionList.length > 0"
    >
      <button
        type="button"
        *ngFor="let item of searchSuggetionList"
        (click)="searchSelect(item)"
      >
        <span [innerHTML]="item.displayName"></span>
      </button>
    </div>
  </form>
</header>

<div
  *ngIf="isMenuOpen || isMenuClosing"
  class="mobile-navigation-overlay"
  [class.mobile-navigation-overlay--closing]="isMenuClosing"
  (click)="closeMobileMenu()"
  aria-hidden="true"
></div>

<aside
  #mobileSheet
  *ngIf="isMenuOpen || isMenuClosing"
  class="mobile-navigation-sheet"
  [class.mobile-navigation-sheet--closing]="isMenuClosing"
  role="dialog"
  aria-modal="true"
  aria-labelledby="mobile-navigation-title"
  tabindex="-1"
>
  <div class="mobile-navigation-sheet__top">
    <img src="../../../../assets/images/logo-text.png" alt="CitizeX" />
    <button
      type="button"
      (click)="closeMobileMenu()"
      aria-label="Close navigation menu"
    >
      <span class="cx-mobile-close-icon" aria-hidden="true"></span>
    </button>
  </div>

  <ng-container *ngIf="mobileMenuPanel === 'menu'; else mobileAlerts">
    <div class="mobile-navigation-sheet__profile">
      <img
        [src]="getAvatarUrl(defaultProfile.profileImage)"
        onerror="this.src='/assets/images/noprofile2.png';"
        alt=""
      />
      <span>
        <strong id="mobile-navigation-title">{{ accountDisplayName }}</strong>
        <small>&#64;{{ accountHandle }}</small>
      </span>
      <a
        *ngIf="defaultProfile.id"
        [routerLink]="['/profile/edit-profile', defaultProfile.id]"
      >
        Edit
      </a>
    </div>

    <nav class="mobile-navigation-sheet__nav" aria-label="Main navigation">
      <p>Go to</p>
      <a routerLink="/events">
        <app-icon name="calendar-days" aria-hidden="true"></app-icon>
        <span
          ><strong>Virtual Events</strong
          ><small>Join live community conversations</small></span
        >
        <app-icon name="chevron-right" aria-hidden="true"></app-icon>
      </a>
      <a routerLink="/representatives">
        <app-icon name="user-round" aria-hidden="true"></app-icon>
        <span><strong>My Representatives &amp; Elections</strong></span>
        <app-icon name="chevron-right" aria-hidden="true"></app-icon>
      </a>
      <a routerLink="/polls">
        <app-icon name="list-checks" aria-hidden="true"></app-icon>
        <span><strong>Current Polls</strong></span>
        <app-icon name="chevron-right" aria-hidden="true"></app-icon>
      </a>
      <a routerLink="/posts">
        <app-icon name="message-square-text" aria-hidden="true"></app-icon>
        <span><strong>Trending Posts</strong></span>
        <app-icon name="chevron-right" aria-hidden="true"></app-icon>
      </a>

      <p>Account</p>
      <a
        *ngIf="defaultProfile.tagName"
        [routerLink]="['/profile/view-profile', defaultProfile.tagName]"
      >
        <app-icon name="notebook-pen" aria-hidden="true"></app-icon>
        <span><strong>Your Page</strong></span>
        <app-icon name="chevron-right" aria-hidden="true"></app-icon>
      </a>
      <button type="button" (click)="showMobileAlerts()">
        <app-icon name="bell" aria-hidden="true"></app-icon>
        <span><strong>Alerts</strong></span>
        <span
          *ngIf="notificationCount > 0"
          class="mobile-navigation-sheet__badge"
        >
          {{ notificationCount > 99 ? '99+' : notificationCount }}
        </span>
        <app-icon name="chevron-right" aria-hidden="true"></app-icon>
      </button>
      <a
        *ngIf="defaultProfile.tagName"
        [routerLink]="['/profile/view-profile', defaultProfile.tagName]"
        [queryParams]="{ tab: 'rsvpEvents' }"
      >
        <app-icon name="calendar-days" aria-hidden="true"></app-icon>
        <span><strong>My Events</strong></span>
        <app-icon name="chevron-right" aria-hidden="true"></app-icon>
      </a>
      <a routerLink="/account-settings">
        <app-icon name="settings" aria-hidden="true"></app-icon>
        <span><strong>Account and settings</strong></span>
        <app-icon name="chevron-right" aria-hidden="true"></app-icon>
      </a>
    </nav>

    <button
      type="button"
      class="mobile-navigation-sheet__logout"
      (click)="logOut()"
    >
      <app-icon name="log-out" aria-hidden="true"></app-icon>
      Log out
    </button>
  </ng-container>

  <ng-template #mobileAlerts>
    <div class="mobile-navigation-sheet__alerts-header">
      <button
        type="button"
        (click)="mobileMenuPanel = 'menu'"
        aria-label="Back to menu"
      >
        <app-icon
          name="chevron-left"
          class="cx-icon--xs"
          aria-hidden="true"
        ></app-icon>
      </button>
      <h2>Alerts</h2>
    </div>
    <div class="mobile-navigation-sheet__alerts">
      <button
        type="button"
        *ngFor="let notification of notificationList"
        [class.mobile-navigation-sheet__alert--unread]="!notification.isRead"
        (click)="updateNotification(notification)"
      >
        <strong>{{ notification.byProfileName || 'CitizeX' }}</strong>
        <span>{{ notificationLabel(notification) }}</span>
        <small>{{ notification.daysAgo }}</small>
      </button>
      <p *ngIf="notificationList.length === 0">You’re all caught up.</p>
    </div>
  </ng-template>
</aside>

<!-- category-header -->

<header class="category-header" *ngIf="headerStyle == 'category'">
  <div
    class="container h-100 overflow-visible px-0 mobile-category-header-padding"
  >
    <div class="row m-0 h-100">
      <div class="col-sm-12 m-0 px-0">
        <h1 class="h-100 text-left center">
          <div>
            <a [routerLink]="['/category']" class="title"> CitizeX Admin </a>
          </div>
          <div class="dropdown dropdown-img menu center navigation-menu">
            <button
              class="btn dropdown-toggle btn-img-circle fix-avtar-2-5"
              type="button"
              id="dropdownMenu"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src="../../../../assets/images/noprofile2.png"
                alt="Profile Image"
              />
            </button>
            <div
              class="dropdown-menu dropdown-menu-right mr-0 shadow"
              aria-labelledby="dropdownMenuButton"
            >
              <button
                type="button"
                class="close btn btn-link btn-tbl-link-danger"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-target=".navigation-menu"
              >
                <app-icon name="x"></app-icon>
              </button>
              <div
                class="text-center px-3 py-2"
                (click)="$event.stopPropagation()"
              >
                <button
                  [routerLink]="[
                    '/profile/view-profile/',
                    defaultProfile.tagName
                  ]"
                  (click)="$event.stopPropagation()"
                  class="btn btn-img-circle fix-avtar-4 my-1 mx-auto"
                >
                  <img
                    *ngIf="
                      defaultProfile.profileImage == '' ||
                      defaultProfile.profileImage == null
                    "
                    src="../../../../assets/images/noprofile2.png"
                    alt="Profile Image"
                  />
                  <img
                    *ngIf="
                      defaultProfile.profileImage != '' &&
                      defaultProfile.profileImage != null
                    "
                    [src]="getAvatarUrl(defaultProfile.profileImage)"
                    onerror="this.src='../../../assets/images/noprofile2.png';"
                    alt="Profile Image"
                  />
                </button>
                <h4 class="p-1">
                  {{ nonVerifiedUser.firstName }} {{ nonVerifiedUser.lastName }}
                </h4>
                <h6 class="p-1">&#64;{{ nonVerifiedUser.userName }}</h6>
              </div>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/category']"
                ><app-icon name="list-checks"></app-icon> Category</a
              >
              <a class="dropdown-item" [routerLink]="['/category/addCategory']"
                ><app-icon name="plus"></app-icon> Add Category</a
              >
              <a class="dropdown-item" [routerLink]="['/deduplication']"
                ><app-icon name="plus"></app-icon> Deduplication</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/spam-reports']"
                ><app-icon
                  name="triangle-alert"
                  class="cx-icon--sm spam-img"
                  aria-hidden="true"
                ></app-icon>
                Spam Reports</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/verify-profiles']"
                ><app-icon name="user-round"></app-icon> User Profiles</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/claim-request']"
                ><app-icon name="circle-alert"></app-icon> Claim Request</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/dashboard']"
                ><app-icon
                  name="notebook-pen"
                  class="cx-icon--sm dashboard-img"
                  aria-hidden="true"
                ></app-icon>
                Dashboard
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="logOut()"
                ><app-icon name="log-out"></app-icon> Logout</a
              >
              <!-- <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="logOut()"><app-icon name="log-out"></app-icon> Logout</a> -->
            </div>
          </div>
        </h1>
      </div>
    </div>
  </div>
</header>
<!-- category-header Ends-->

<app-post-review-model></app-post-review-model>

<header class="profile-header" *ngIf="headerStyle == 'privacyAndPolicy'">
  <nav class="navbar navbar-expand-md py-0 minh-100 site-content-container">
    <div class="col-auto">
      <a
        [routerLink]="['/portal']"
        class="navbar-brand btn btn-img-no-effect h-40px d-block border-0"
      >
        <img
          src="../../../../assets/images/logo-text.png"
          class=""
          alt="Logo Image"
        />
      </a>
    </div>
  </nav>
</header>

<!-- Restriction Modal -->
<div
  class="modal fade"
  id="restrictModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <app-icon name="circle-alert" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          Please complete all the verification steps first.
        </p>
        <div class="col-12 text-center">
          <button
            [routerLink]="['/signup']"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Get Verified
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!-- #restrictModal -->
<!-- Restriction Modal Ends -->

<!-- Restriction Modal -->
<div
  class="modal fade"
  id="restrictProfileModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <app-icon name="circle-alert" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          You must have your own profile on CitizeX to post a review.
        </p>
        <div class="col-12 text-center">
          <button
            [routerLink]="['/profile/search-profile']"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Create your page
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!-- #restrictModal -->
<!-- Restriction Modal Ends -->

<div
  class="modal fade"
  id="createPageModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-md"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-2 mb-2">Create a Page</h5>
        <button
          type="button"
          class="close mt-2 font-32"
          aria-label="Close"
          data-dismiss="modal"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-justify theme-color mb-2">
          As a verified user, you must create a page with your information
          before you can start posting reviews. Please make sure that your first
          name, last name and date of birth matches your government issued ID
          used for verification.
        </p>
        <p class="text-justify theme-color mb-2">
          Once you create your own page, you will be able to create pages for
          other individuals. However, any page created for any individual will
          remain "unclaimed" until claimed by the individual.
        </p>
        <p class="text-justify theme-color mb-2">
          *Please refrain from making fake or duplicate pages else your account
          will be flagged!
        </p>
        <div class="col-12 text-center">
          <button
            class="btn btn-black mt-4 mb-2 mx-2 py-2 px-sm-2 px-3 font-14"
            (click)="redirectToCreateProfilePage()"
          >
            Continue
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>

<!-- Restriction Modal -->
<div
  class="modal fade"
  id="restrictUnclaimedProfileModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <app-icon name="circle-alert" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          To access this feature, your claim request needs to be approved. Your
          request is currently under review, and you’ll be notified within 24–48
          hours.
        </p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Ok
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!-- #restrictModal -->

<!-- have feedback modal  -->
<div
  class="modal fade havefeedbackmodal account-dialog account-dialog--feedback"
  tabindex="-1"
  role="dialog"
  id="haveFeedback"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered account-dialog__dialog"
    role="document"
  >
    <div class="modal-content account-dialog__content">
      <div class="modal-header account-dialog__header">
        <h5 class="modal-title">Have feedback?</h5>
        <button
          type="button"
          class="close account-dialog__close"
          aria-label="Close"
          data-dismiss="modal"
          (click)="resetFormData(feedbackForm)"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body account-dialog__body">
        <form
          #feedbackForm="ngForm"
          (ngSubmit)="sendBugReportOrFeedback(feedbackForm)"
          novalidate
        >
          <div class="account-dialog__feedback-types" role="radiogroup">
            <label
              class="account-dialog__feedback-type"
              [class.is-selected]="reportBugFeedbackDTO.type === 'report a bug'"
            >
              <input
                type="radio"
                name="feedback"
                value="report a bug"
                [(ngModel)]="reportBugFeedbackDTO.type"
                required
                #type="ngModel"
              />
              <span>Report a bug</span>
            </label>
            <label
              class="account-dialog__feedback-type"
              [class.is-selected]="reportBugFeedbackDTO.type === 'feedback'"
            >
              <input
                type="radio"
                name="feedback"
                value="feedback"
                [(ngModel)]="reportBugFeedbackDTO.type"
                required
                #type="ngModel"
              />
              <span>Feedback</span>
            </label>
          </div>
          <div
            *ngIf="feedbackForm.submitted && type.invalid"
            class="text-danger mb-2 text-center"
          >
            Please select a feedback type.
          </div>
          <div class="form-group account-dialog__field">
            <label for="description">Description</label>
            <textarea
              id="description"
              class="form-control"
              rows="5"
              [(ngModel)]="reportBugFeedbackDTO.description"
              name="description"
              required
              maxlength="1000"
              #description="ngModel"
              NoLeadingWhitespace
              placeholder="What happened, and what did you expect instead?"
            ></textarea>
            <div
              *ngIf="feedbackForm.submitted && description.invalid"
              class="text-danger"
            >
              <span *ngIf="description.errors?.['required']"
                >Description is required.</span
              >
              <span *ngIf="description.errors?.['maxlength']"
                >You've reached the maximum limit of 1000 characters.</span
              >
            </div>
          </div>
          <div class="account-dialog__footer">
            <button
              type="button"
              class="btn account-dialog__secondary"
              data-dismiss="modal"
              (click)="resetFormData(feedbackForm)"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn account-dialog__primary"
              [disabled]="feedbackForm.invalid"
            >
              {{
                reportBugFeedbackDTO.type === 'feedback'
                  ? 'Send feedback'
                  : 'Send bug report'
              }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- have feedback modal  -->
<!----------------Update-My-Address-Modal-------------->
<div
  class="modal fade"
  id="UpdateAddressModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <!-- <div class="modal-header">
        <h3 class="modal-title font-20 fw-600" id="exampleModalLongTitle">Update my address</h3>
        <button
        type="button"
        class="close mt-2 font-32"
        aria-label="Close"
        data-dismiss="modal">
        <span aria-hidden="true"><app-icon name="x" class="cx-icon--sm" aria-hidden="true"></app-icon></span>
      </button>
      </div> -->
      <div class="modal-body">
        <p class="font-16 fw-600">
          Please complete the verification using an ID that has your updated
          address.
        </p>
        <div class="col-12 text-center mt-4 mb-2 mx-2">
          <button
            type="button"
            class="btn btn-outline-black font-16 fw-400"
            (click)="verifymodal()"
          >
            ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!---------------------verify-Modal----------------->
<div
  id="identityVerificationHeaderModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="identityVerificationHeaderModalTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body p-5">
        <button
          aria-label="Close"
          class="close close-modal"
          data-dismiss="modal"
          type="button"
        >
          <app-icon name="x"></app-icon>
        </button>
        <h3 id="identityVerificationHeaderModalTitle" class="text-center">
          Didit Verification
        </h3>
        <p class="mb-0 mt-3 text-center text-muted">
          Preparing your secure identity verification session...
        </p>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="diditErrorModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered conversation-Modal"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-700 font-18" id="exampleModalLongTitle">
          Error
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mt-2" *ngIf="diditStatus == 'rejection'">
          <span style="font-size: 14px" class="verified">
            Your request has been rejected due to a mismatch in ID.
            <!-- To update your user information, please click here and try again.
            <a style="color: #161616;" data-dismiss="modal" [routerLink]="['/edit-user']"><u class="fw-700"
                style="text-decoration: none;">Click
                here</u></a>
            and retry. -->
          </span>
          <p class="font-13 fw-600 mt-2">
            Possible reasons for the rejection include:
          </p>
          <div class="col mt-1 pl-4 mb-2">
            <ul class="ul-style">
              <li class="list-symbol">
                Missing middle name in the 'first and middle name' field during
                sign-up.
              </li>
              <li class="list-symbol">
                The name entered at sign-up does not match the name on your ID.
              </li>
              <li class="list-symbol">An extra space after your last name.</li>
            </ul>
          </div>
        </div>
        <div *ngIf="diditStatus == 'declined'">
          <span style="font-size: 15px" class="verified">
            Your request has been declined , please retry.</span
          >
        </div>
        <div class="col-12 text-center mt-3">
          <button
            type="button"
            class="btn btn-black font-14"
            data-dismiss="modal"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Update address Model  -->
<div
  class="modal fade"
  id="UpdateAddressesModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  data-backdrop="static"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <p class="font-16 fw-600">Address Updated</p>
        <div class="col-12 text-center mt-4 mb-2 mx-2">
          <button
            type="button"
            class="btn btn-outline-black font-16 fw-400"
            data-dismiss="modal"
            (click)="closePopup()"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!------------------------Update-Phone-No-Modal------------------->
<div
  id="phoneNumberModalHeader"
  class="modal fade account-dialog account-dialog--phone"
  tabindex="-1"
  role="dialog"
  aria-labelledby="phoneNumberModalTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme account-dialog__dialog"
    role="document"
  >
    <div class="modal-content account-dialog__content">
      <div class="modal-header account-dialog__header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Update phone number
        </h5>
        <button
          type="button"
          class="close account-dialog__close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="resetFormData(f)"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body account-dialog__body">
        <div
          *ngIf="otpResendCooldownMsg"
          class="col-md-12 my-2 alert alert-danger"
        >
          {{ otpResendCooldownMsg }}
          <button
            (click)="otpResendCooldownMsg = ''"
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span class="text-danger"
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>
        <form
          class="row square-form needs-validation account-dialog__form account-dialog__phone-form"
          (ngSubmit)="sendOTP(f.invalid)"
          #f="ngForm"
          novalidate
          autocomplete="off"
        >
          <div class="mobile-input-with-flag">
            <label for="countryCode" class="control-label fw-600">
              Mobile number</label
            >
            <div class="account-dialog__phone-control">
              <div class="account-dialog__phone-flag">
                <img
                  *ngIf="selectedCountry?.flagUrl"
                  [src]="selectedCountry.flagUrl"
                  class="country-flag-img"
                  alt="flag"
                />
                <img
                  *ngIf="!selectedCountry?.flagUrl"
                  src="assets/images/flag_placeholder.png"
                  class="flag flag-us"
                  alt="flag"
                />
              </div>
              <div class="account-dialog__phone-country">
                <div class="country-code-dropdown">
                  <button
                    id="countryCode"
                    class="btn country-code-btn form-control"
                    type="button"
                    (click)="toggleCountryDropdown($event)"
                    aria-label="Choose country calling code"
                    [attr.aria-expanded]="countryDropdownOpen"
                  >
                    {{ selectedCountry?.callingCode || '+1' }}
                    <app-icon
                      name="chevron-down"
                      class="cx-icon--xs"
                      aria-hidden="true"
                    ></app-icon>
                  </button>
                  <div
                    class="country-dropdown-menu"
                    *ngIf="countryDropdownOpen"
                  >
                    <div
                      class="country-search-wrap cx-search-control px-2 pb-1"
                    >
                      <app-icon
                        name="search"
                        class="cx-search-control__icon"
                        aria-hidden="true"
                      ></app-icon>
                      <input
                        #countrySearchInput
                        type="search"
                        class="form-control country-search-input cx-search-control__input"
                        placeholder="Search country..."
                        [(ngModel)]="countrySearchTerm"
                        (input)="filterCountries()"
                        name="countrySearchHeader"
                        autocomplete="off"
                        (click)="$event.stopPropagation()"
                      />
                      <button
                        *ngIf="countrySearchTerm"
                        type="button"
                        class="cx-search-control__clear"
                        (click)="
                          countrySearchTerm = '';
                          filterCountries();
                          $event.stopPropagation()
                        "
                        aria-label="Clear country search"
                      >
                        <app-icon name="x" aria-hidden="true"></app-icon>
                      </button>
                    </div>
                    <div class="country-list">
                      <a
                        class="dropdown-item country-item"
                        *ngFor="let country of filteredCountries"
                        (click)="selectCountry(country)"
                      >
                        <img
                          [src]="country.flagUrl"
                          class="country-flag-img"
                          alt="flag"
                        />
                        <span class="country-name">{{ country.name }}</span>
                        <span class="country-code ml-auto">{{
                          country.callingCode
                        }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="account-dialog__phone-number">
                <input
                  type="text"
                  class="form-control account-dialog__phone-input"
                  id="phoneNumber"
                  name="phoneNumber"
                  [(ngModel)]="phoneNumber"
                  (ngModelChange)="phoneNoErrMsg = ''; phoneChangeError = ''"
                  inputmode="tel"
                  required
                  mask="(000) 000-0000"
                  #phoneCtrl="ngModel"
                  minlength="10"
                />
              </div>
            </div>
            <div
              *ngIf="f.submitted && (phoneCtrl.touched || phoneCtrl.invalid)"
              class="text-danger account-dialog__phone-error"
            >
              <span *ngIf="phoneCtrl.errors?.['required']"
                >Phone number is required.</span
              >
              <span *ngIf="phoneCtrl.errors?.['pattern']"
                >Phone number must be exactly 10 digits.</span
              >
            </div>
            <div
              *ngIf="phoneNoErrMsg || phoneChangeError"
              class="invalid-feedback d-block account-dialog__phone-error"
              role="alert"
            >
              {{ phoneNoErrMsg || phoneChangeError }}
            </div>
            <p class="account-dialog__help">
              We'll text a code to this number to confirm it.
            </p>
            <div class="account-dialog__footer">
              <button
                type="button"
                class="btn account-dialog__secondary"
                data-dismiss="modal"
                (click)="resetFormData(f)"
              >
                Cancel
              </button>
              <input
                type="submit"
                class="btn account-dialog__primary"
                value="Send Code"
                [disabled]="
                  otpResendBlocked || otpSendInFlight || phoneCtrl.invalid
                "
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!----------------------Verification-Modal------------------>
<div
  id="phoneOtpModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="phoneNumberModalTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600" id="exampleModalLongTitle">
          Update Phone No
        </h5>
        <button
          type="button"
          class="close"
          (click)="resetFormData(otpModal)"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <form
            class="row px-4 square-form needs-validation"
            (ngSubmit)="otpVerify(otpModal)"
            #otpModal="ngForm"
            novalidate
            autocomplete="off"
          >
            <div
              *ngIf="otpResent && !otpResendBlocked"
              class="col-md-12 my-2 alert alert-info"
            >
              OTP sent again.
              <button
                (click)="otpResent = false"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
            <div
              *ngIf="otpResendCooldownMsg"
              class="col-md-12 my-2 alert alert-danger"
            >
              {{ otpResendCooldownMsg }}
              <button
                (click)="otpResendCooldownMsg = ''"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span class="text-danger"
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
            <div
              *ngIf="phoneChangeError"
              class="alert alert-danger col-md-12 my-2"
            >
              {{ phoneChangeError }}
              <button
                (click)="phoneChangeError = ''"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span class="text-danger"
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
            <div class="col-12">
              <label
                for="input"
                class="col-12 m-0 text-center control-label font-16 fw-600"
                >Enter Code</label
              >
              <div class="col-10 activation-grid item-4 form-group mx-auto">
                <div
                  [ngClass]="{
                    'is-invalid':
                      invalidOTP == true ||
                      (otpModal.submitted &&
                        (otpModal.untouched || otpModal.invalid))
                  }"
                  *ngFor="
                    let item of otpCodeArr;
                    let index = index;
                    trackBy: trackByIndex
                  "
                >
                  <div class="input-field my-0">
                    <input
                      type="text"
                      [attr.tabindex]="index + 1"
                      [attr.id]="'otpCode' + index"
                      [name]="'otpCode' + index"
                      class="form-control text-center activation-field h-2"
                      maxlength="1"
                      [(ngModel)]="otpCodeArr[index]"
                      required
                      inputmode="tel"
                      (paste)="onPestCode($event, 'otpCode', 4)"
                      (input)="keytabOTP(index, $event, 'input')"
                      (keyup)="keytabOTP(index, $event, 'keyup')"
                    />
                  </div>
                </div>
              </div>
              <div class="text-center mt-2 invalid-feedback d-block">
                <!-- invalid-feedback -->
                <span *ngIf="otpModal.submitted && otpModal.invalid">
                  Please enter verification code sent to your registered phone.
                </span>
                <span *ngIf="invalidOTP">
                  {{ otpVerificationError || 'Invalid OTP.' }}
                </span>
              </div>
            </div>
            <!-- .col -->

            <div class="col-md-12 pt-4 text-center">
              <button type="submit" class="btn btn-black mt-2" tabindex="5">
                Continue
              </button>
              <p class="font-14 font-gray mt-3">
                Didn't get verification code?
                <button
                  type="button"
                  (click)="resendOTP(otpModal)"
                  class="btn btn-link btn-link-theme font-14 p-0"
                  tabindex="6"
                  [disabled]="otpResendBlocked || otpSendInFlight"
                >
                  &nbsp;Resend now
                </button>
              </p>
            </div>
            <!-- .col -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<!--------------Update-My-Email-Modal--------------->
<div
  class="modal fade update-email-modal account-dialog account-dialog--email"
  id="emailModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom account-dialog__dialog"
    role="document"
  >
    <div class="modal-content account-dialog__content">
      <div class="modal-header account-dialog__header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Update email address
        </h5>
        <button
          type="button"
          (click)="resetFormData(emailform)"
          class="close account-dialog__close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body account-dialog__body">
        <div *ngIf="errMsg != ''" class="col-md-12 my-2 alert alert-danger">
          {{ errMsg }}
          <button
            type="button"
            (click)="errMsg = ''"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>
        <form
          class="account-dialog__form"
          #emailform="ngForm"
          (ngSubmit)="updateEmailOrPhoneNo('', '', email, emailform)"
          novalidate
        >
          <div class="form-group account-dialog__field">
            <label for="email">Email address</label>
            <input
              type="email"
              [(ngModel)]="email"
              name="email"
              id="email"
              class="form-control email-input"
              pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9]+([\-\.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$"
              required
              NoLeadingWhitespace
              #emailId="ngModel"
            />
            <div
              class="text-danger mt-2"
              *ngIf="emailform.submitted && emailId.invalid"
            >
              <span *ngIf="emailId.errors?.['required']">
                Please enter Email address.
              </span>
              <span *ngIf="emailId.errors?.['pattern']">
                Please enter a valid Email address.
              </span>
            </div>
            <p class="account-dialog__help">
              We'll email a code to this address to confirm it.
            </p>
          </div>
          <div class="account-dialog__footer">
            <button
              type="button"
              class="btn account-dialog__secondary"
              data-dismiss="modal"
              (click)="resetFormData(emailform)"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn account-dialog__primary"
              [disabled]="emailId.invalid"
            >
              Send code
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-----------set-Otp-Modal--------->
<div
  class="modal fade otp-modal"
  id="otpModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600" id="exampleModalLongTitle">
          Update Email
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="resetFormData(emailVerification)"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div
          *ngIf="activationsent == true"
          class="col-md-12 my-2 alert alert-info"
        >
          Verification Code sent again.
          <button
            type="button"
            (click)="activationsent = false"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>
        <p class="font-14 fw-600 text-center">
          Kindly check your email for verification code to update email.
        </p>
        <form
          (ngSubmit)="activationCodeVerify(emailVerification.invalid)"
          #emailVerification="ngForm"
          novalidate
        >
          <label class="font-16 fw-700 text-center col-12 mt-3"
            >Enter the verification code</label
          >
          <div class="col-12 activation-grid form-group mt-1">
            <div
              [ngClass]="{
                'is-invalid':
                  incorrectActCode == true ||
                  (emailVerification.submitted &&
                    (emailVerification.untouched || emailVerification.invalid))
              }"
              *ngFor="
                let item of actCodeArr;
                let index = index;
                trackBy: trackByIndex
              "
            >
              <div class="input-field my-0">
                <input
                  type="text"
                  tabindex="{{ index + 1 }}"
                  id="activationCode{{ index }}"
                  name="actCodee[index]"
                  class="form-control text-center activation-field h-2"
                  maxlength="1"
                  required
                  #act="ngModel"
                  (input)="keytab(this.index, $event, 'input')"
                  (keyup)="keytab(this.index, $event, 'keyup')"
                  (focus)="onFocusEvent($event)"
                  (paste)="onPestCode($event, 'activationCode', 6)"
                  [(ngModel)]="actCodeArr[index]"
                  inputmode="tel"
                />
              </div>
            </div>
            <div class="text-center invalid-feedback">
              <span
                *ngIf="
                  emailVerification.submitted &&
                  (emailVerification.untouched || emailVerification.invalid)
                "
              >
                Please Enter Verifcation Code.
              </span>
              <span *ngIf="incorrectActCode == true">
                Invalid verification Code.
              </span>
            </div>
          </div>
          <div class="col-12 text-center mt-4">
            <button type="submit" class="btn btn-outline-black">Update</button>
            <p class="my-2">
              Didn't receive verification code?<button
                type="button"
                (click)="resendActivationCode(f)"
                class="btn btn-link btn-link-theme"
              >
                Resend now
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!------------------email-Update-sucessfully-Modal------------------->
<div
  class="modal fade"
  id="emailSucessfully"
  tabindex="-1"
  role="dialog"
  aria-labelledby="emailSucessfully"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body pt-4 px-3">
        <h5 class="font-18 fw-600 mt-3">
          Your email address has been changed successfully. To ensure account
          security, please sign in again with your new email.
        </h5>
        <div class="col-12 text-center mt-4">
          <button
            type="button"
            data-dismiss="modal"
            (click)="logOut()"
            class="btn btn-black"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Name Setting Modal -->
<!-- <div class="modal fade" id="namePrefModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content p-3">
      <div class="modal-header">
        <h5 class="modal-title">Name Display Preference</h5>
      </div>

      <div class="modal-body">
        <p>Please select how you wish to show your public name:</p>

        <div class="form-group mb-2">
          <label>First Name:</label>
  
          <select class="form-control" [(ngModel)]="nameSettingDTO.nameDisplayPreference.firstName"
            (change)="generatePreview()" [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs" name="nameSettingDTO.nameDisplayPreference.firstName">
            <option value="full">Full</option>
            <option value="initial">Initial</option>
            <option value="hide">Hide</option>
          </select>
        </div>

        <div *ngIf="fullName.middleName" class="form-group mb-2">
          <label>Middle Name:</label>
          <select class="form-control" [(ngModel)]="nameSettingDTO.nameDisplayPreference.middleName"
            (change)="generatePreview()" [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs" name="nameSettingDTO.nameDisplayPreference.middleName">
            <option value="full">Full</option>
            <option value="initial">Initial</option>
            <option value="hide">Hide</option>
          </select>
        </div>

        <div class="form-group mb-2">
          <label>Last Name:</label>
          <select class="form-control" [(ngModel)]="nameSettingDTO.nameDisplayPreference.lastName"
            (change)="generatePreview()" [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs" name="nameSettingDTO.nameDisplayPreference.lastName">
            <option value="full">Full</option>
            <option value="initial">Initial</option>
            <option value="hide">Hide</option>
          </select>
        </div>

        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" id="keepAsIs"
            [(ngModel)]="nameSettingDTO.nameDisplayPreference.keepAsIs" (change)="onKeepAsIsChange($event)" name="nameSettingDTO.nameDisplayPreference.keepAsIs">
          <label class="form-check-label" for="keepAsIs">Keep it as it is</label>
        </div>

        <div class="alert alert-info">
          <strong>Preview:</strong> {{ previewName }}
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" data-dismiss="modal" (click)="fetchNameSetting()">Cancel</button>
        <button class="btn btn-primary" (click)="updateNameSetting()">Save</button>
      </div>
    </div>
  </div>
</div> -->
<div
  class="modal fade account-dialog account-dialog--name"
  id="namePrefModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom name-setting-modal account-dialog__dialog"
    role="document"
  >
    <div class="modal-content account-dialog__content">
      <div class="modal-header account-dialog__header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          How should your name appear?
        </h5>
        <button
          type="button"
          class="close account-dialog__close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeNameSettingPopup()"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body account-dialog__body">
        <div
          class="col-md-12 my-2 alert alert-danger"
          *ngIf="errorMessage != ''"
        >
          {{ errorMessage }}
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>
        <form
          class="square-form account-dialog__form account-dialog__name-form"
        >
          <div
            class="col-12 mt-3"
            *ngIf="fullName.prefix && nameSettingDTO?.nameDisplayPreference"
          >
            <label id="prefix-preference-label" class="font-14 fw-600"
              >Prefix:</label
            >
            <div class="account-dialog__name-select">
              <button
                type="button"
                class="account-dialog__name-select-trigger"
                data-name-preference-trigger="prefix"
                aria-haspopup="listbox"
                aria-labelledby="prefix-preference-label"
                [attr.aria-expanded]="openNamePreferenceMenu === 'prefix'"
                (click)="toggleNamePreferenceMenu('prefix', $event)"
              >
                <span>{{
                  namePreferenceLabel(
                    nameSettingDTO.nameDisplayPreference.prefix
                  )
                }}</span>
                <app-icon
                  name="chevron-down"
                  class="cx-icon--xs"
                  aria-hidden="true"
                ></app-icon>
              </button>
              <div
                *ngIf="openNamePreferenceMenu === 'prefix'"
                class="account-dialog__name-select-menu"
                role="listbox"
                aria-labelledby="prefix-preference-label"
              >
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.prefix === 'full'
                  "
                  (click)="selectNamePreference('prefix', 'full')"
                >
                  Full
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.prefix === 'hide'
                  "
                  (click)="selectNamePreference('prefix', 'hide')"
                >
                  Hide
                </button>
              </div>
            </div>
          </div>
          <div
            class="col-12 mt-3"
            *ngIf="nameSettingDTO?.nameDisplayPreference"
          >
            <label id="first-name-preference-label" class="font-14 fw-600"
              >First Name:</label
            >
            <div class="account-dialog__name-select">
              <button
                type="button"
                class="account-dialog__name-select-trigger"
                data-name-preference-trigger="firstName"
                [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs"
                aria-haspopup="listbox"
                aria-labelledby="first-name-preference-label"
                [attr.aria-expanded]="openNamePreferenceMenu === 'firstName'"
                (click)="toggleNamePreferenceMenu('firstName', $event)"
              >
                <span>{{
                  namePreferenceLabel(
                    nameSettingDTO.nameDisplayPreference.firstName
                  )
                }}</span>
                <app-icon
                  name="chevron-down"
                  class="cx-icon--xs"
                  aria-hidden="true"
                ></app-icon>
              </button>
              <div
                *ngIf="openNamePreferenceMenu === 'firstName'"
                class="account-dialog__name-select-menu"
                role="listbox"
                aria-labelledby="first-name-preference-label"
              >
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.firstName === 'full'
                  "
                  (click)="selectNamePreference('firstName', 'full')"
                >
                  Full
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.firstName === 'initial'
                  "
                  (click)="selectNamePreference('firstName', 'initial')"
                >
                  Initial
                </button>
                <button
                  *ngIf="fullName.middleName"
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.firstName === 'hide'
                  "
                  (click)="selectNamePreference('firstName', 'hide')"
                >
                  Hide
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.firstName === 'custom'
                  "
                  (click)="selectNamePreference('firstName', 'custom')"
                >
                  Custom
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <input
              *ngIf="
                nameSettingDTO?.nameDisplayPreference?.firstName === 'custom'
              "
              type="text"
              class="form-control mt-2 custom-input"
              name="customFirstName"
              placeholder="Enter custom first name"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.customFirstName"
              (input)="generatePreview()"
            />
          </div>

          <div
            class="col-12 mt-3"
            *ngIf="fullName.middleName && nameSettingDTO?.nameDisplayPreference"
          >
            <label id="middle-name-preference-label" class="font-14 fw-600"
              >Middle Name:</label
            >
            <div class="account-dialog__name-select">
              <button
                type="button"
                class="account-dialog__name-select-trigger"
                data-name-preference-trigger="middleName"
                [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs"
                aria-haspopup="listbox"
                aria-labelledby="middle-name-preference-label"
                [attr.aria-expanded]="openNamePreferenceMenu === 'middleName'"
                (click)="toggleNamePreferenceMenu('middleName', $event)"
              >
                <span>{{
                  namePreferenceLabel(
                    nameSettingDTO.nameDisplayPreference.middleName
                  )
                }}</span>
                <app-icon
                  name="chevron-down"
                  class="cx-icon--xs"
                  aria-hidden="true"
                ></app-icon>
              </button>
              <div
                *ngIf="openNamePreferenceMenu === 'middleName'"
                class="account-dialog__name-select-menu"
                role="listbox"
                aria-labelledby="middle-name-preference-label"
              >
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.middleName === 'full'
                  "
                  (click)="selectNamePreference('middleName', 'full')"
                >
                  Full
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.middleName ===
                    'initial'
                  "
                  (click)="selectNamePreference('middleName', 'initial')"
                >
                  Initial
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.middleName === 'hide'
                  "
                  (click)="selectNamePreference('middleName', 'hide')"
                >
                  Hide
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.middleName === 'custom'
                  "
                  (click)="selectNamePreference('middleName', 'custom')"
                >
                  Custom
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <input
              *ngIf="
                nameSettingDTO?.nameDisplayPreference?.middleName === 'custom'
              "
              type="text"
              class="form-control mt-2 custom-input"
              name="customMiddleName"
              placeholder="Enter custom middle name"
              [(ngModel)]="
                nameSettingDTO.nameDisplayPreference.customMiddleName
              "
              (input)="generatePreview()"
            />
          </div>

          <div
            class="col-12 mt-3"
            *ngIf="nameSettingDTO?.nameDisplayPreference"
          >
            <label id="last-name-preference-label" class="font-14 fw-600"
              >Last Name:</label
            >
            <div class="account-dialog__name-select">
              <button
                type="button"
                class="account-dialog__name-select-trigger"
                data-name-preference-trigger="lastName"
                [disabled]="nameSettingDTO.nameDisplayPreference.keepAsIs"
                aria-haspopup="listbox"
                aria-labelledby="last-name-preference-label"
                [attr.aria-expanded]="openNamePreferenceMenu === 'lastName'"
                (click)="toggleNamePreferenceMenu('lastName', $event)"
              >
                <span>{{
                  namePreferenceLabel(
                    nameSettingDTO.nameDisplayPreference.lastName
                  )
                }}</span>
                <app-icon
                  name="chevron-down"
                  class="cx-icon--xs"
                  aria-hidden="true"
                ></app-icon>
              </button>
              <div
                *ngIf="openNamePreferenceMenu === 'lastName'"
                class="account-dialog__name-select-menu account-dialog__name-select-menu--up"
                role="listbox"
                aria-labelledby="last-name-preference-label"
              >
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.lastName === 'full'
                  "
                  (click)="selectNamePreference('lastName', 'full')"
                >
                  Full
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.lastName === 'initial'
                  "
                  (click)="selectNamePreference('lastName', 'initial')"
                >
                  Initial
                </button>
                <button
                  *ngIf="fullName.middleName"
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.lastName === 'hide'
                  "
                  (click)="selectNamePreference('lastName', 'hide')"
                >
                  Hide
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.lastName === 'custom'
                  "
                  (click)="selectNamePreference('lastName', 'custom')"
                >
                  Custom
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <input
              *ngIf="
                nameSettingDTO?.nameDisplayPreference?.lastName === 'custom'
              "
              type="text"
              class="form-control mt-2 custom-input"
              name="customLastName"
              placeholder="Enter custom last name"
              [(ngModel)]="nameSettingDTO.nameDisplayPreference.customLastName"
              (input)="generatePreview()"
            />
          </div>

          <div
            class="col-12 mt-3"
            *ngIf="fullName.suffix && nameSettingDTO?.nameDisplayPreference"
          >
            <label id="suffix-preference-label" class="font-14 fw-600"
              >Suffix:</label
            >
            <div class="account-dialog__name-select">
              <button
                type="button"
                class="account-dialog__name-select-trigger"
                data-name-preference-trigger="suffix"
                aria-haspopup="listbox"
                aria-labelledby="suffix-preference-label"
                [attr.aria-expanded]="openNamePreferenceMenu === 'suffix'"
                (click)="toggleNamePreferenceMenu('suffix', $event)"
              >
                <span>{{
                  namePreferenceLabel(
                    nameSettingDTO.nameDisplayPreference.suffix
                  )
                }}</span>
                <app-icon
                  name="chevron-down"
                  class="cx-icon--xs"
                  aria-hidden="true"
                ></app-icon>
              </button>
              <div
                *ngIf="openNamePreferenceMenu === 'suffix'"
                class="account-dialog__name-select-menu account-dialog__name-select-menu--up"
                role="listbox"
                aria-labelledby="suffix-preference-label"
              >
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.suffix === 'full'
                  "
                  (click)="selectNamePreference('suffix', 'full')"
                >
                  Full
                </button>
                <button
                  type="button"
                  role="option"
                  [attr.aria-selected]="
                    nameSettingDTO.nameDisplayPreference.suffix === 'hide'
                  "
                  (click)="selectNamePreference('suffix', 'hide')"
                >
                  Hide
                </button>
              </div>
            </div>
          </div>
          <div
            class="form-group mt-0 col-12 mt-3"
            *ngIf="nameSettingDTO?.nameDisplayPreference"
          >
            <div class="checkbox">
              <input
                class="form-check-input"
                type="checkbox"
                id="keepAsIs"
                name="keepAsIs"
                [(ngModel)]="nameSettingDTO.nameDisplayPreference.keepAsIs"
                (change)="onKeepAsIsChange($event)"
              />
              <label for="keepAsIs" class="checkbox-label font-14 fw-600"
                >Keep it as it is</label
              >
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="preview-msg">
              <span>Shows as</span>
              <strong>{{ previewName }}</strong>
            </div>
          </div>
          <div class="col-12 mt-3 account-dialog__footer">
            <button
              class="btn account-dialog__secondary"
              data-dismiss="modal"
              (click)="closeNameSettingPopup()"
            >
              Cancel
            </button>
            <button
              class="btn account-dialog__primary"
              [disabled]="disable"
              (click)="updateNameSetting()"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!---------------Virtual-event-Modal---------------->
<!-- <div class="modal fade" id="virtualEventModal" tabindex="-1" role="dialog"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-dialog-custom" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-600 font-20" >Virtual Event Settings</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><app-icon name="x" class="cx-icon--sm" aria-hidden="true"></app-icon></span>
        </button>
      </div>
      <div class="modal-body pt-4 px-3">
         <form>
            <div class="col-12 px-0 d-flex" *ngIf="user">
              <label class="switch">
                <input type="checkbox" [(ngModel)]="user.isSubscribedToVirtualEvents" (ngModelChange)="virtualEventNotification($event)"
                  name="notifyToggle">
                <span class="slider round"></span>
              </label>
              <p class="font-16 fw-600 ml-3">Notify me for all virtual events</p>
            </div>
        </form>
      </div>
    </div>
  </div>
</div> -->
<!-- Event has not started modal -->
<div
  class="modal fade"
  id="eventNotStartedModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <app-icon name="circle-alert" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">The event has not started yet</p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Claim Approved Modal -->
<div
  class="modal fade"
  id="claimApprovedModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center text-success">
          <app-icon name="shield-check" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Congratulations!</h6>
        <p class="text-center theme-color">
          Your claim request has been approved.
        </p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
            (click)="approvedOk()"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Claim Rejected Modal -->
<div
  class="modal fade"
  id="claimRejectedModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center text-danger">
          <app-icon name="shield-x" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Request Rejected</h6>
        <p class="text-center theme-color">
          Your claim request has been rejected.
        </p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
            (click)="rejectedOk()"
          >
            Create your page
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
